import { MyTicketsProvider } from './context';
// eslint-disable-next-line import/no-cycle
import { MyTicketsContainer } from './MyTicketsContainer';

export function MyTicketsPage() {
  return (
    <MyTicketsProvider>
      <MyTicketsContainer />
    </MyTicketsProvider>
  );
}
